import React from "react";
import { Animated } from "react-animated-css";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
// import { toEnglishNum, toPersianNum } from "../../assets/utils";
// import { setLoginPhoneNumber } from "../../redux/login/login.actions";
import {
  // selectLoginPhoneNumber,
  selectLoginStep,
} from "../../redux/login/login.selectors";
import InputPhoneNumber from "../inputPhoneNumber/inputPhoneNumber.component";
import LoginPhoneInitialStep from "../loginPhoneInitialStep/loginPhoneInitialStep.component";
import InputSentCode from "../inputSentCode/inputSentCode.component";
import {
  LoginPhoneFirstStepStyled,
  ProcessAlertContStyled,
  RightColor,
  AlertText,
} from "./loginPhoneFirstStep.styles";

const LoginPhoneFirstStep = ({ loginStep }) => {
  const CafeBazar = "https://cafebazaar.ir/app/com.barman.bar.driver";
  const AlertMessage =
    "اگر راننده باری هستید، این پیام را لمس کرده و اپلیکیشن رانندگان را دانلود کنید";
  return (
    <LoginPhoneFirstStepStyled>
      {loginStep === -1 && <LoginPhoneInitialStep />}
      {loginStep === 0 && <InputPhoneNumber />}
      {loginStep === 1 && (
        <>
          {/* <Animated
            animationIn="bounceInDown"
            // animationOut="bounceOutRight"
            animationInDuration={500}
            animationOutDuration={0}
            isVisible={loginStep === 1}
            className="animated position-relative overflow-hidden mb-4"
          > */}
            <InputSentCode />
          {/* </Animated> */}

          {/* <ProcessAlertContStyled
            color={"red"}
            onClick={() => window.window.open(CafeBazar, "_blank")}
          >
            <RightColor color={"red"}>!</RightColor>
            <AlertText>{AlertMessage}</AlertText>
          </ProcessAlertContStyled> */}
        </>
      )}
    </LoginPhoneFirstStepStyled>
  );
};

const mapStateToProps = createStructuredSelector({
  loginStep: selectLoginStep,
});

// const mapDispatchToProps = (dispatch) => ({
//   setLoginPhoneNumber: (x) => dispatch(setLoginPhoneNumber(x)),
// });

export default connect(mapStateToProps)(LoginPhoneFirstStep);
// mapStateToProps,
// mapDispatchToProps
